<template>
  <div>
    <div class="d-flex justify-end">
      <v-card-actions>
        <v-overlay :value="overlay" class="d-flex">
          <div class="d-flex justify-end">
            <v-btn icon @click="overlay = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <user-assign
            :userId="parseInt(userId)"
            @save="userAssign"
          ></user-assign>
        </v-overlay>
      </v-card-actions>
    </div>

    <div class="notice" v-if="!setupComplete">
      User has not completed their account setup by configuring a password!
    </div>

    <div class="profile-card" flat>
      <v-avatar v-if="!userIsLoggedInUser()" size="80px">
        <img id="js-avatar" :src="avatar" alt="personal avatar missing?" />
      </v-avatar>
    </div>

    <v-card class="profile-card" flat>
      <v-btn
        v-if="isPresident() || isManager() || userIsLoggedInUser()"
        id="js-user-edit-btn"
        class="mx-2"
        fab
        x-small
        color="secondary"
        dark
        @click="editMode = !editMode"
      >
        <v-icon dark>mdi-pencil</v-icon>
      </v-btn>
      <v-card-title>Personal</v-card-title>
      <v-simple-table class="pl-4">
        <tbody>
          <tr>
            <th>First Name</th>
            <td v-if="!editMode" id="js-firstName">
              {{ firstName }}
            </td>
            <td v-else>
              <v-text-field
                outlined
                single-line
                dense
                hide-details
                :value="firstName"
                @blur="saveFirstName"
              ></v-text-field>
            </td>
          </tr>
          <tr>
            <th color="primary">Last Name</th>
            <td v-if="!editMode" id="js-lastName">{{ lastName }}</td>
            <td v-else>
              <v-text-field
                outlined
                single-line
                dense
                hide-details
                :value="lastName"
                @blur="saveLastName"
              ></v-text-field>
            </td>
          </tr>

          <tr>
            <th color="primary">Nickname</th>
            <td v-if="!editMode" id="js-nickname">{{ nickname }}</td>
            <td v-else>
              <v-text-field
                outlined
                single-line
                dense
                hide-details
                id="js-nickname-input"
                :value="nickname"
                @blur="saveNickname"
              ></v-text-field>
            </td>
          </tr>

          <tr>
            <th>Email</th>
            <td v-if="!editMode" id="js-email">{{ email }}</td>
            <td v-else>
              <v-text-field
                outlined
                single-line
                dense
                hide-details
                id="js-email-input"
                :value="email"
                @blur="saveEmail"
              ></v-text-field>
            </td>
          </tr>
          <tr>
            <th>Phone Number</th>
            <td v-if="!editMode" id="js-phone-number">
              {{ phoneNumber }}
            </td>
            <td v-else>
              <v-text-field
                outlined
                single-line
                dense
                hide-details
                id="js-phone-number-input"
                :value="phoneNumber"
                @blur="savePhoneNumber"
              ></v-text-field>
            </td>
          </tr>

          <tr>
            <th>System Phone Number</th>
            <td id="js-system-phone-number">
              {{ systemPhoneNumber }}
            </td>
          </tr>

          <tr v-if="!setupComplete">
            <th>Invite Email</th>
            <td>
              <v-btn
                id="js-invite_email"
                class="default-action-btn"
                small
                @click="sendInviteEmail()"
                v-if="emailValid"
              >
                {{ resetSent ? "Re-Send" : "Send" }}
              </v-btn>
              <span class="setup-email-sent" v-if="resetSent"
                >Setup email has been sent.</span
              >
            </td>
          </tr>

          <tr v-if="isPresident() || isManager()">
            <th>Program Start Date</th>
            <td v-if="!editMode" id="js-program-start-date">
              {{ programStartDate }}
            </td>
            <td v-else>
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    outlined
                    single-line
                    dense
                    hide-details
                    readonly
                    :value="programStartDate"
                    hint="MM/DD/YYYY format"
                    @blur="date = parseDate(programStartDate)"
                    @click="date = parseDate(programStartDate)"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  no-title
                  @input="saveProgramStartDate"
                ></v-date-picker>
              </v-menu>
            </td>
          </tr>

          <tr v-if="isPresident() || isManager()">
            <th>
              {{ familyLabel }}
              <v-btn
                v-if="isPresident()"
                id="js-user-assign-families-btn"
                class="mx-2"
                fab
                x-small
                color="secondary"
                dark
                @click="overlay = true"
              >
                <v-icon dark>mdi-plus-minus</v-icon>
              </v-btn>
            </th>
            <td id="js-familyName">
              {{ families }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>

    <v-card v-if="isPresident() || isManager()" class="profile-card" flat>
      <v-card-title>Parent 1</v-card-title>
      <v-simple-table class="pl-2 pr-2">
        <tbody>
          <tr>
            <th>Name</th>
            <td v-if="!editMode" id="js-parent-name-1">
              {{ parentName1 }}
            </td>
            <td v-else>
              <v-text-field
                outlined
                single-line
                dense
                hide-details
                id="js-parent-name-1-input"
                :value="parentName1"
                @blur="saveParentName1"
              ></v-text-field>
            </td>
          </tr>

          <tr>
            <th>Phone Number</th>
            <td v-if="!editMode" id="js-parent-phone-1">
              {{ parentPhone1 }}
            </td>
            <td v-else>
              <v-text-field
                outlined
                single-line
                dense
                hide-details
                id="js-parent-phone-1-input"
                :value="parentPhone1"
                @blur="saveParentPhone1"
              ></v-text-field>
            </td>
          </tr>
          <tr>
            <th>Email</th>
            <td v-if="!editMode" id="js-parent-email-1">
              {{ parentEmail1 }}
            </td>
            <td v-else>
              <v-text-field
                outlined
                single-line
                dense
                hide-details
                id="js-parent-email-1-input"
                :value="parentEmail1"
                @blur="saveParentEmail1"
              ></v-text-field>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>

    <v-card v-if="isPresident() || isManager()" class="profile-card" flat>
      <v-card-title>Parent 2</v-card-title>
      <v-simple-table class="pl-4">
        <tbody>
          <tr>
            <th>Name</th>
            <td v-if="!editMode" id="js-parent-name-2">
              {{ parentName2 }}
            </td>
            <td v-else>
              <v-text-field
                outlined
                single-line
                dense
                hide-details
                id="js-parent-name-2-input"
                :value="parentName2"
                @blur="saveParentName2"
              ></v-text-field>
            </td>
          </tr>
          <tr>
            <th>Phone Number</th>
            <td v-if="!editMode" id="js-parent-phone-2">
              {{ parentPhone2 }}
            </td>
            <td v-else>
              <v-text-field
                outlined
                single-line
                dense
                hide-details
                id="js-parent-phone-2-input"
                :value="parentPhone2"
                @blur="saveParentPhone2"
              ></v-text-field>
            </td>
          </tr>
          <tr>
            <th>Email</th>
            <td v-if="!editMode" id="js-parent-email-2">
              {{ parentEmail2 }}
            </td>
            <td v-else>
              <v-text-field
                outlined
                single-line
                dense
                hide-details
                id="js-parent-email-2-input"
                :value="parentEmail2"
                @blur="saveParentEmail2"
              ></v-text-field>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>

    <v-card v-if="isPresident() || isManager()" class="profile-card" flat>
      <v-card-title>Siblings</v-card-title>
      <v-simple-table class="pl-4">
        <tbody>
          <tr>
            <th>Names</th>
            <td v-if="!editMode" id="js-siblings">{{ siblings }}</td>
            <td v-else>
              <v-text-field
                outlined
                single-line
                dense
                hide-details
                id="js-siblings-input"
                :value="siblings"
                @blur="saveSiblings"
              ></v-text-field>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>
    <v-card class="profile-card" flat>
      <v-card-title>School</v-card-title>
      <v-simple-table class="pl-4">
        <tbody>
          <tr>
            <th>Name</th>
            <td v-if="!editMode" id="js-school">{{ school }}</td>
            <td v-else>
              <v-text-field
                outlined
                single-line
                dense
                hide-details
                id="js-school-input"
                :value="school"
                @blur="saveSchool"
              ></v-text-field>
            </td>
          </tr>
          <tr>
            <th>Graduation Year</th>
            <td v-if="!editMode" id="js-graduation-year">
              {{ graduationYear }}
            </td>
            <td v-else>
              <v-text-field
                outlined
                single-line
                dense
                hide-details
                id="js-graduation-year-input"
                :value="graduationYear"
                @blur="saveGraduationYear"
              ></v-text-field>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card>
    <v-card
      v-if="isPresident() || isManager()"
      id="js-assessment-credentials-section"
      class="profile-card"
      flat
    >
      <v-card-title>Assessment Automation</v-card-title>
      <v-simple-table class="pl-4">
        <tbody>
          <tr>
            <th>Enneagram Doc</th>
            <td v-if="!editMode" id="js-enneagram-doc">{{ enneagramDoc }}</td>
            <td v-else>
              <v-file-input
                id="enneagramDocFileInput"
                v-on:change="fileSelected"
                v-model="files"
                label="Enneagram Results Document"
              ></v-file-input>
            </td>
            <td v-if="enneagramDoc && !editMode">
              <v-btn
                id="js-enneagram-doc-parse"
                small
                class="default-action-btn ml-6"
                @click="initiateParse()"
                >parse</v-btn
              >
            </td>
            <td v-else-if="editMode">
              <v-btn
                v-if="this.file"
                v-on:click="submitFiles"
                class="default-action-btn"
                small
                id="js-upload"
                >upload</v-btn
              >
            </td>
            <td v-else></td>
          </tr>
          <tr>
            <th>Pro-D</th>
            <td v-if="!editMode" id="js-pro-d-order-number">
              {{ proDOrderNumber }}
            </td>
            <td v-else>
              <v-text-field
                outlined
                single-line
                dense
                hide-details
                id="js-pro-d-order-number-input"
                :value="proDOrderNumber"
                @blur="saveProDOrderNumber"
              ></v-text-field>
            </td>
            <td>
              <v-btn
                v-if="
                  !editMode && proDOrderNumber && proDOrderNumber.length > 0
                "
                id="js-pro-d-fetch"
                class="default-action-btn"
                small
                @click="fetchProD"
              >
                <v-icon class="mr-2">mdi-cloud-download-outline</v-icon>fetch
              </v-btn>
            </td>
          </tr>
          <tr>
            <th>Pro-D status</th>
            <td colspan="2" id="js-pro-d-status-graphic">
              <v-progress-circular
                v-if="polling"
                indeterminate
                color="primary"
              ></v-progress-circular>
              <span class="pro-d-status" v-else
                ><v-icon>{{ proDStatusIcon }}</v-icon
                ><span
                  id="js-pro-d-status-text"
                  v-if="proDStatus && proDStatus.includes('error')"
                  class="ml-2"
                  >{{ proDStatus }}</span
                ></span
              >
            </td>
          </tr>
        </tbody>
      </v-simple-table>

      <v-card class="disabled-card" flat v-if="isPresident() || isManager()">
        <v-card-title>Status</v-card-title>
        <v-simple-table class="pl-4">
          <tbody>
            <tr>
              <th>Enabled</th>
              <td v-if="!editMode">
                <v-icon v-if="enabled">mdi-checkbox-marked-outline</v-icon>
                <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
              </td>
              <td v-else>
                <v-checkbox v-model="enabled"> </v-checkbox>
              </td>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">mdi-information</v-icon>
                </template>
                <span
                  >Disabling a user, resets their password, and logs them out of
                  any active sessions.</span
                >
              </v-tooltip>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>

      <v-btn
        v-if="isPresident() || isManager() || userIsLoggedInUser()"
        id="js-user-edit-btn"
        class="ma-2"
        fab
        x-small
        color="secondary"
        dark
        @click="editMode = !editMode"
      >
        <v-icon dark>mdi-pencil</v-icon>
      </v-btn>
    </v-card>
    <v-card
      class="profile-card"
      flat
      v-if="(isPresident() || isManager()) && !userIsLoggedInUser()"
    >
      <v-card-title>Mentor Notes</v-card-title>
      <user-note-add @add-user-note-event="addUserNote"></user-note-add>
      <user-note
        v-for="(note, i) in userNotes"
        :key="i"
        :note="note"
      ></user-note>
    </v-card>
  </div>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"
import userMixin from "@/mixins/userMixin"
import { mapGetters } from "vuex"
import UserAssign from "@/containers/users/UserAssign"
import UserNote from "@/components/users/UserNote"
import UserNoteAdd from "@/components/users/UserNoteAdd"
import { AssessmentsAPI, UsersAPI } from "@/lib/api"

export default {
  mixins: [eventMixin, userMixin],
  components: { UserAssign, UserNote, UserNoteAdd },
  computed: {
    ...mapGetters("users", ["getUser"]),
    ...mapGetters("assessments", ["getAssessmentsByUserId"]),
    assessments() {
      if (this.getAssessmentsByUserId(this.userId)) {
        return this.getAssessmentsByUserId(this.userId).assessments
      }
    },
    avatar() {
      return this.getUser(this.userId) ? this.getUser(this.userId).avatar : ""
    },
    firstName() {
      return this.getUser(this.userId)
        ? this.getUser(this.userId).first_name
        : ""
    },
    lastName() {
      return this.getUser(this.userId)
        ? this.getUser(this.userId).last_name
        : ""
    },
    familyLabel() {
      let label = "Family"

      if (this.getUser(this.userId) && this.getUser(this.userId).families) {
        let families = this.getUser(this.userId).families
        if (families.length > 1) {
          label = "Families"
        }
      }
      return label
    },
    families() {
      let families =
        this.getUser(this.userId) && this.getUser(this.userId).families
          ? this.getUser(this.userId).families
          : []
      var returnString = families
        .map(el => {
          return el.name
        })
        .join(", ")
      return returnString
    },
    email() {
      let email = this.getUser(this.userId)
        ? this.getUser(this.userId).email
        : ""
      this.emailValid = /.+@.+/.test(email)
      return email
    },
    phoneNumber() {
      return this.getUser(this.userId) && this.getUser(this.userId).phone_number
        ? this.formatUSNumber(this.getUser(this.userId).phone_number)
        : ""
    },
    systemPhoneNumber() {
      return this.getUser(this.userId) &&
        this.getUser(this.userId).system_number
        ? this.getUser(this.userId).system_number
        : ""
    },
    nickname() {
      return this.getUser(this.userId) ? this.getUser(this.userId).nickname : ""
    },
    parentName1() {
      return this.getUser(this.userId)
        ? this.getUser(this.userId).parent_name_1
        : ""
    },
    parentName2() {
      return this.getUser(this.userId)
        ? this.getUser(this.userId).parent_name_2
        : ""
    },
    parentPhone1() {
      return this.getUser(this.userId) &&
        this.getUser(this.userId).parent_phone_1
        ? this.formatUSNumber(this.getUser(this.userId).parent_phone_1)
        : ""
    },
    parentPhone2() {
      return this.getUser(this.userId) &&
        this.getUser(this.userId).parent_phone_2
        ? this.formatUSNumber(this.getUser(this.userId).parent_phone_2)
        : ""
    },
    parentEmail1() {
      return this.getUser(this.userId)
        ? this.getUser(this.userId).parent_email_1
        : ""
    },
    parentEmail2() {
      return this.getUser(this.userId)
        ? this.getUser(this.userId).parent_email_2
        : ""
    },
    siblings() {
      return this.getUser(this.userId) ? this.getUser(this.userId).siblings : ""
    },
    school() {
      return this.getUser(this.userId) ? this.getUser(this.userId).school : ""
    },
    graduationYear() {
      return this.getUser(this.userId)
        ? this.getUser(this.userId).graduation_year
        : ""
    },
    programStartDate() {
      return this.getUser(this.userId)
        ? this.formatDate(
            new Date(this.getUser(this.userId).program_start_date)
              .toISOString()
              .substr(0, 10)
          )
        : ""
    },
    setupComplete() {
      return this.getUser(this.userId)
        ? this.getUser(this.userId).setup_complete
        : false
    },
    resetSent() {
      return this.getUser(this.userId)
        ? this.getUser(this.userId).reset_sent
        : false
    },
    userNotes() {
      return this.getUser(this.userId) && this.getUser(this.userId).notes
        ? this.getUser(this.userId).notes
        : []
    },
    proDOrderNumber() {
      return this.getUser(this.userId)
        ? this.getUser(this.userId).pro_d_order_number
        : ""
    },
    proDStatus() {
      return this.getUser(this.userId)
        ? this.getUser(this.userId).pro_d_status
        : ""
    },
    proDStatusIcon() {
      let i = "mdi-checkbox-blank-outline"
      if (this.proDStatus == "done") {
        i = "mdi-checkbox-marked-outline"
      } else if (this.proDStatus && this.proDStatus.includes("error")) {
        i = "mdi-alert-outline"
      }
      return i
    },
    enneagramDoc() {
      const enneagramData = this.getAssessmentByType("Enneagram")
      return enneagramData ? enneagramData.document_name : ""
    },
    enabled: {
      get: function() {
        return this.getUser(this.userId)
          ? !this.getUser(this.userId).disabled
          : undefined
      },
      set: function(val) {
        if (!val) {
          this.$store.dispatch("users/disableUser", this.userId)
        } else {
          this.$store.dispatch("users/updateUser", {
            id: this.userId,
            disabled: false
          })
        }
      }
    }
  },
  props: {
    userId: { type: Number } // the userId of the displayed user. not necessarily the logged in user.
  },
  data: function() {
    return {
      overlay: false,
      emailValid: false,
      menu1: false,
      date: this.programStartDate,
      editMode: false,
      poller: null,
      polling: false,
      files: [],
      file: ""
    }
  },
  created() {
    this.$store.dispatch("users/loadUser", parseInt(this.userId))
    this.$store.dispatch("assessments/assessmentsByUserId", {
      userId: this.userId
    })
  },
  watch: {
    userId: function(newValue, oldValue) {
      this.$store.dispatch("assessments/assessmentsByUserId", {
        userId: newValue
      })
    }
  },
  methods: {
    getAssessmentByType(type) {
      return this.assessments
        ? this.assessments.find(el => el.type == type)
        : {}
    },
    fileSelected(File) {
      this.file = File
    },
    submitFiles() {
      console.log("about to upload the enneagram doc: ")
      console.log("user id: " + this.userId)
      console.log("document name: " + this.file.name)

      AssessmentsAPI.uploadEnneagramDoc(this.userId, this.file).then(() => {
        this.$store.dispatch("assessments/assessmentsByUserId", {
          userId: this.userId
        })
      })
      this.file = ""
      this.files = []
      this.editMode = false
    },
    initiateParse() {
      this.$store.dispatch("users/parseEnneagram", this.userId)
    },
    fetchProD() {
      this.polling = true
      this.$store.dispatch("users/fetchProD", this.userId)
      this.pollForProDDone()
    },
    pollForProDDone() {
      this.poller = setInterval(() => {
        this.loadUser()
      }, 5000)
    },
    loadUser() {
      this.$store.dispatch("users/loadUser", this.userId)
      if (
        this.proDStatus == "done" ||
        this.proDStatus == "ready" ||
        (this.proDStatus && this.proDStatus.includes("error"))
      ) {
        this.polling = false
        clearInterval(this.poller)
      }
    },
    sendInviteEmail() {
      this.$store.dispatch("users/sendUserInvite", this.userId)
    },
    saveFirstName(e) {
      this.$store.dispatch("users/updateUser", {
        id: this.userId,
        firstName: e.target.value
      })
    },
    saveLastName(e) {
      this.$store.dispatch("users/updateUser", {
        id: this.userId,
        lastName: e.target.value
      })
    },
    saveNickname(e) {
      this.$store.dispatch("users/updateUser", {
        id: this.userId,
        nickname: e.target.value
      })
    },
    saveParentName1(e) {
      this.$store.dispatch("users/updateUser", {
        id: this.userId,
        parentName1: e.target.value
      })
    },
    saveParentName2(e) {
      this.$store.dispatch("users/updateUser", {
        id: this.userId,
        parentName2: e.target.value
      })
    },
    saveParentPhone1(e) {
      this.$store.dispatch("users/updateUser", {
        id: this.userId,
        parentPhone1: e.target.value
      })
    },
    saveParentPhone2(e) {
      this.$store.dispatch("users/updateUser", {
        id: this.userId,
        parentPhone2: e.target.value
      })
    },
    saveParentEmail1(e) {
      this.$store.dispatch("users/updateUser", {
        id: this.userId,
        parentEmail1: e.target.value
      })
    },
    saveParentEmail2(e) {
      this.$store.dispatch("users/updateUser", {
        id: this.userId,
        parentEmail2: e.target.value
      })
    },
    saveSiblings(e) {
      this.$store.dispatch("users/updateUser", {
        id: this.userId,
        siblings: e.target.value
      })
    },
    saveProDOrderNumber(e) {
      this.$store.dispatch("users/updateUser", {
        id: this.userId,
        pro_d_order_number: e.target.value
      })
    },
    saveSchool(e) {
      this.$store.dispatch("users/updateUser", {
        id: this.userId,
        school: e.target.value
      })
    },
    saveGraduationYear(e) {
      this.$store.dispatch("users/updateUser", {
        id: this.userId,
        graduationYear: e.target.value
      })
    },
    saveProgramStartDate() {
      this.menu1 = false
      this.$store.dispatch("users/updateUser", {
        id: this.userId,
        programStartDate: this.date
      })
    },
    saveEmail(e) {
      // Update whether the current email is valid
      this.emailValid = /.+@.+/.test(e.target.value)
      this.$store.dispatch("users/updateUser", {
        id: this.userId,
        email: e.target.value
      })
    },
    savePhoneNumber(e) {
      this.$store.dispatch("users/updateUser", {
        id: this.userId,
        phoneNumber: e.target.value
      })
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split("-")
      return `${month}/${day}/${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [month, day, year] = date.split("/")
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
    },
    formatUSNumber(entry) {
      let formattedNumber = entry

      let match = entry
        .replace(/\D+/g, "")
        .replace(/^1/, "")
        .match(/([^\d]*\d[^\d]*){1,10}$/)

      if (match && match.length > 0) {
        match = match[0]

        const part1 = match.length > 2 ? `(${match.substring(0, 3)})` : match
        const part2 = match.length > 3 ? ` ${match.substring(3, 6)}` : ""
        const part3 = match.length > 6 ? `-${match.substring(6, 10)}` : ""

        formattedNumber = `${part1}${part2}${part3}`
      }

      return formattedNumber
    },
    userIsLoggedInUser() {
      return this.getUserId() == this.userId
    },
    addUserNote(e) {
      this.$store.dispatch("users/addUserNote", {
        userId: this.userId,
        note: e.noteBody
      })
    },
    userAssign() {
      this.overlay = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";

.setup-email-sent {
  margin-left: 25px;
  color: $dark-blue;
  font-style: italic;
  font-size: 1.4em;
}

.pro-d-status {
  color: $dark-blue;
  font-style: italic;
  font-size: 1.4em;
}

tbody {
  color: $dark-grey;
}
th {
  width: 30%;
  border-bottom: 1px solid $beige;
  text-transform: uppercase;
  font-style: italic;
}

td {
  border-bottom: 1px solid $beige !important;
}

tr:hover {
  background: $beige !important;
}

div.notice {
  font-size: 2em;
  font-style: italic;
  color: $white;
  background-color: $orange;
  border-radius: 5px;
  text-align: center;
  margin: 30px;
}

.profile-card {
  padding: 0 10px;
  margin: 30px auto;
  max-width: 650px;
  .v-card__title {
    text-transform: uppercase;
    color: $dark-grey;
  }
}
</style>
